import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-open_mobile",
  "use": "icon-open_mobile-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-open_mobile\">\r\n<rect width=\"32\" height=\"32\" rx=\"16\" fill=\"#1C1F33\" />\r\n<rect x=\"8\" y=\"10\" width=\"16\" height=\"2\" rx=\"1\" fill=\"white\" />\r\n<rect x=\"8\" y=\"15\" width=\"16\" height=\"2\" rx=\"1\" fill=\"white\" />\r\n<rect x=\"8\" y=\"20\" width=\"16\" height=\"2\" rx=\"1\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol